(() => {
  function initialise(root = document) {
    root.querySelectorAll('[data-gp-variant-backorder]').forEach(block => {
      if (block.dataset.ready) return;
      const form = block.closest('form');
      const selection = form && form.querySelector('[data-variant-selection]');
      if (!selection) return;
      block.dataset.ready = 'true';
      const dates = JSON.parse(block.querySelector('[data-gp-backorder-dates]').textContent);
      const message = block.querySelector('[data-gp-backorder-message]');
      const property = block.querySelector('[data-gp-backorder-property]');
      const section = block.closest('.shopify-section');
      const gallery = section && section.querySelector('.product-gallery__main');
      let picturedVariant;
      function syncImage() {
        const id = selection.getAttribute('variant');
        if (!gallery || !gallery.classList.contains('flickity-enabled') || id === picturedVariant) return;
        picturedVariant = id;
        const entry = dates[id];
        if (!entry || !entry.mediaId) return;
        const image = gallery.querySelector(`[data-image-id="${entry.mediaId}"]`);
        const thumbnails = gallery.closest('.product-gallery').querySelectorAll('.product-gallery__thumbnail');
        const thumbnail = image && thumbnails[Number(image.dataset.index)];
        if (thumbnail) thumbnail.click();
      }
      if (gallery && !gallery.classList.contains('flickity-enabled')) {
        const galleryReady = new MutationObserver(() => {
          if (gallery.classList.contains('flickity-enabled')) {
            syncImage();
            galleryReady.disconnect();
          }
        });
        galleryReady.observe(gallery, { attributes: true, attributeFilter: ['class'] });
      }
      function update() {
        const id = selection.getAttribute('variant');
        const entry = dates[id];
        const label = entry ? entry.label : '';
        message.querySelector('[data-gp-dispatch-date]').textContent = label ? `Estimated dispatch ${entry.date}` : '';
        block.hidden = !label;
        message.hidden = !label;
        property.value = label;
        property.disabled = !label;
        syncImage();
        if (entry && entry.available) {
          const text = label ? 'Backorder' : block.dataset.addLabel;
          form.querySelectorAll('[data-add-to-cart-trigger]').forEach(button => {
            button.dataset.label = text;
            button.querySelectorAll('span:not(.icon)').forEach(span => { span.textContent = text; });
          });
          if (label) form.querySelectorAll('.shopify-payment-button').forEach(button => { button.style.display = 'none'; });
        }
      }
      selection.addEventListener('variant-change', () => queueMicrotask(update));
      new MutationObserver(update).observe(selection, { attributes: true, attributeFilter: ['variant'] });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
